import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { ActionLabelModule } from '../../molecules/action-label/action-label.module';
import { InputModule } from '../input/input.module';
import { AutocompleteComponent } from './autocomplete.component';
import { ReplaceModule } from '../../../pipes/replace/replace.module';
import { InputComponent } from '../input/input.component';

@NgModule({
  imports: [
    ErrorTooltipModule,
    CommonModule,
    ActionLabelModule,
    InputModule,
    ReplaceModule
  ],
  declarations: [AutocompleteComponent],
  exports: [AutocompleteComponent, InputComponent, ReplaceModule]
})
export class AutocompleteModule {}
